import { fetchUtils } from "react-admin";
import { userApi } from "../url";

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
    options.headers.set("Access-Control-Allow-Origin", "*");
  }
  if (localStorage.getItem("accessToken")) {
    options.headers.set(
      "Authorization",
      `Bearer ${localStorage.getItem("accessToken")}`,
    );
  }
  return fetchUtils.fetchJson(url, options);
};

const authProvider = {
  login: async ({ username, password }) => {
    const response = await httpClient(`${userApi}/admin/login`, {
      method: "POST",
      body: JSON.stringify({ username, password }),
    }).then(({ json }) => {
      return json;
    });
    if (response.error) {
      return Promise.reject();
    } else {
      localStorage.setItem("accessToken", response.accessToken);
      localStorage.setItem("refreshToken", response.refreshToken);
      localStorage.setItem("adminId", response.admin.id);
      return Promise.resolve();
    }
  },
  checkError: (error) => Promise.resolve(),
  checkAuth: async (params) => {
    //get accessToken
    const accessToken = localStorage.getItem("accessToken");
    if (
      !accessToken ||
      accessToken === "undefined" ||
      accessToken === "null" ||
      accessToken === ""
    ) {
      return Promise.reject();
    }
    if (!isTokenExpired(accessToken)) {
      return Promise.resolve();
    }
    console.log("checkAuth");
    //refresh token
    const refreshToken = localStorage.getItem("refreshToken");

    if (
      refreshToken &&
      refreshToken !== "undefined" &&
      refreshToken !== "null" &&
      refreshToken !== ""
    ) {
      const response = await httpClient(`${userApi}/admin/refreshToken`, {
        method: "POST",
        body: JSON.stringify({
          refreshToken: refreshToken,
        }),
      }).then(({ json }) => {
        return json;
      });
      localStorage.setItem("accessToken", response.result);
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
  logout: () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    return Promise.resolve();
  },
  //   getIdentity: async () => {
  //     if (localStorage.getItem("adminId")) {
  //       const response = await httpClient(
  //         `${api}/user/${localStorage.getItem("adminId")}`,
  //         {
  //           method: "GET",
  //         }
  //       ).then(({ json }) => {
  //         return json;
  //       });
  //       return Promise.resolve(response.result);
  //     }
  //   },
  getPermissions: () => Promise.resolve(),
};

function isTokenExpired(token) {
  const expiry = JSON.parse(atob(token.split(".")[1])).exp;
  return Math.floor(new Date().getTime() / 1000) >= expiry;
}

export default authProvider;
